import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateRangeSelector from '../../../Components/DateRangeSelector/DateRangeSelector';
import { connect } from 'react-redux';
import { actions } from '../../../Reducks/VirtualEvents';
import moment from 'moment-timezone';
import { ReportType } from '../../../Utils/Constants';

export class VirtualEventsDateRangeSelector extends Component {
  static propTypes = {
    uniqueId: PropTypes.string.isRequired,
    isBig: PropTypes.bool.isRequired,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    }),
    getVirtualEvents: PropTypes.func,
    filter: PropTypes.object,
    fetching: PropTypes.bool,
    reportType: PropTypes.string
  };

  render() {
    const { uniqueId, isBig, filter, fetching, getVirtualEvents, mixpanelData, reportType } = this.props;
    return (
      <DateRangeSelector
        reactDatesProps={{
          isOutsideRange: day =>
            day.isAfter(
              moment()
                .add(1, 'year')
                .endOf('day')
            ) ||
            day.isBefore(
              moment()
                .subtract(2, 'year')
                .endOf('day')
            )
        }}
        uniqueId={uniqueId}
        isBig={isBig}
        onApply={(startDate, endDate) => getVirtualEvents(startDate, endDate)}
        fromDateTime={filter.fromTime}
        toDateTime={
          reportType === ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT ? new Date().toISOString() : filter.toTime
        }
        defaultFromDateTime={filter.defaultFromDate}
        defaultToDateTime={filter.defaultToDate}
        disabled={fetching}
        futureDates={true}
        mixpanelData={mixpanelData}
      />
    );
  }
}

export default connect(
  null,
  { getVirtualEvents: actions.getVirtualEvents }
)(VirtualEventsDateRangeSelector);



// WEBPACK FOOTER //
// ./src/GoToWebinar/VirtualEvents/Filters/VirtualEventsDateRangeSelector.js